module.exports = __webpack_public_path__ + "Linearicons-Free.65060723fe964f85afa0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.woff?w118d
// module id = ./src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.woff?w118d
// module chunks = styles